module.exports = __webpack_public_path__ + "img/left.4d132f6f.svg";